import styles from './UpliftStat.module.css'

export interface UpliftStatProps {
  label: string
  value: string
  tone?: 'up' | 'plain'
}

export function UpliftStat({ label, value, tone = 'plain' }: UpliftStatProps) {
  return (
    <div className={styles.stat} data-component="uplift-stat">
      <p className={styles.label}>{label}</p>
      <p className={`${styles.value} ${tone === 'up' ? styles.up : ''}`}>{value}</p>
    </div>
  )
}
